<template>
    <div class="comments">
        <div class="comments__body">
            <div class="comments__list">
                <p
                    class="comments__hint"
                    v-if="!comments.length"
                >
                    Add a note or comment...
                </p>
                <comment
                    v-for="comment in comments"
                    :key="comment.id"
                    :comment="comment"
                />
            </div>
        </div>

        <div class="comments__footer">
            <form
                action=""
                class="comments__form"
                @submit.prevent="submit"
            >
                <textarea
                    name="comment_text"
                    id=""
                    cols="30"
                    rows="3"
                    v-model="comment_text"
                    placeholder="Note or comments here..."
                    class="comments__input"
                />
                <attachments
                    @input="attachmentsChanged"
                    ref="attachments"
                />
                <select
                    class="comment_select form-control"
                    :disabled="!sitesAvailable"
                    v-model="localSiteId"
                    @change="siteSelectChanged"
                >
                    <option :value="null">
                        Not site specific
                    </option>
                    <option value="*">
                        All sites
                    </option>
                    <option
                        v-for="site in sites"
                        :key="site.id"
                        :value="site.id"
                    >
                        #{{ site.site_no }} {{ site.name }}
                    </option>
                </select>
                <button 
                    class="comments__button btn btn-primary" 
                    :disabled="!comment_text"
                >
                    Add Comment
                </button>
            </form>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import Service from "../services/CommentsService";
import Comment from "./CommentComponent";
import CustomerService from "../services/CustomerService";
import Attachments from './AttachmentsComponent';

export default {
    components: {
        Comment,
        Attachments,
    },
    
    props: {
        lockSite: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            comment_text: "",
            sites: [],
            localSiteId: '*',
            attachments: [],
        };
    },

    computed: {
        ...mapState("comments", [
            "comments",
            "customerId",
            "siteId",
            "modal_title"
        ]),

        sitesAvailable() {
            return this.sites.length > 0 && !this.lockSite;
        }
    },

    watch: {
        comments() {
            if (this.comments && this.comments.length > 0) {
                this.scrollToBottom();
            }
        },

        customerId() {
            this.load();
        },

        siteId() {
            if (this.siteId !== this.localSiteId) {
                this.localSiteId = this.siteId;
            }
            this.load();
        }
    },

    mounted() {
        this.localSiteId = this.siteId;
        this.load();
    },

    beforeDestroy() {
        this.stopListener();
    },

    methods: {
        ...mapMutations("comments", ["hideModal", "setParams", "setSiteId"]),
        ...mapActions("comments", ["loadComments", "setupListener", "stopListener"]),

        load() {
            this.stopListener();
            if (this.customerId) {
                this.setParams({
                    customerId: this.customerId,
                    siteId: this.siteId,
                });
                this.loadComments();
                this.setupListener();
                this.loadSites();
            }
        },

        submit() {
            if (!this.comment_text || this.comment_text.length < 1) {
                return;
            }
            let siteId = this.siteId;
            if (this.siteId === '*') {
                siteId = null;
            }
            let comment = {
                customer_id: this.customerId,
                site_id: siteId,
                content: this.comment_text,
                attachments: this.attachments,
            };
            Service.store(comment).then(() => {
                this.reset();
            });
        },

        reset() {
            this.comment_text = "";
            this.attachments = [];
            this.$refs.attachments.clear();
        },

        scrollToBottom() {
            window.setTimeout(() => {
                window
                    .$(".comments__body")
                    .animate(
                        {
                            scrollTop: window
                                .$(".comments__body")
                                .prop("scrollHeight")
                        },
                        500
                    );
            }, 1000);
        },

        loadSites() {
            if (!this.customerId) {
                this.sites = [];
                this.siteId = null;
                return;
            }

            CustomerService.get(this.customerId).then(({ data }) => {
                this.sites = data.sites.map(site => {
                    return {
                        id: site.id,
                        name: site.name
                    };
                });
            });
        },

        siteSelectChanged () {
            this.setSiteId(this.localSiteId);
        },

        attachmentsChanged (attachments) {
            this.attachments = attachments;
        },
    }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/CommentsComponent.vue